import EventOverviewFormContainer from './event_overview_form_container';

const EventOverviewForm = EventOverviewFormContainer;
export default EventOverviewForm;
